import { render, staticRenderFns } from "./PageDataSidebar.vue?vue&type=template&id=6f334fb3&scoped=true&"
import script from "./PageDataSidebar.vue?vue&type=script&lang=js&"
export * from "./PageDataSidebar.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/page_data_sidebar.css?vue&type=style&index=0&id=6f334fb3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f334fb3",
  null
  
)

export default component.exports